const vehicles = {
  vehicles: 'Fahrzeuge',

  headerButtons: {
    create: {
      createBtn: 'Erstellen',
    },

    import: 'Importieren',
  },

  import: {
    title: 'Fahrzeuge hochladen',
  },

  toast: {
    error: {
      badResponse: '[Fahrzeug] fehlerhafte Serverantwort',
      edit: {},
      create: {},
    },
    success: {
      edit: {
        resetSuccess: 'Erfolgreich.',
      },
      create: {},
      delete: {
        default: '[Fahrzeug] erfolgreich gelöscht',
      },
    },
  },
  table: {
    headers: {
      name: 'Name',
      make: 'Machen',
      model: 'Modell',
      year: 'Jahr',
      color: 'Farbe',
      pax: 'Max. Passagiere',
      minSeats: 'Mindestanzahl Fahrgäste',
      supplier: 'Anbieter',
      attributes: 'Attribut',
      service: 'Dienst'
    },
    filters: {
      supplier: 'Anbieter',
      attributes: 'Eigenschaften',
      services: 'Leistungen',
    },
    actions: {
      delete: 'Löschen',
      export: 'Exportieren',
    },
    toolTip: {
      noPermission: 'Aktion nicht zulässig: Berechtigung erforderlich',
    },
  },
  deleteModal: {
    header: 'Fahrzeuge löschen',
    body: 'Sie sind dabei, {{num}} Fahrzeuge zu löschen.',
  },

  create: {
    successToast: {
      message: 'Erfolg! Fahrzeug erstellt!',
    },
    errorToast: {
      message: 'Es ist ein Fehler aufgetreten. Fahrzeug konnte nicht erstellt werden.',
    },
  },

  edit: {
    successToast: {
      message: 'Erfolg! Fahrzeug aktualisiert!',
    },
    errorToast: {
      message: 'Ein Fehler ist aufgetreten. Fahrzeug konnte nicht aktualisiert werden.',
    },

    suspendButton: {
      actionActivate: 'Aufheben der Sperre',
      actionDeactivate: 'Sperren',
    },
    suspendModal: {
      popupTitleActive: 'Fahrzeug aussetzen',
      popupTitleDeactivation: 'Fahrzeug aufheben',
      popupTitleUnsuspend: 'Grund für die Aufhebung der Sperrung',
      popupSubTitleDeactivation: 'Wählen Sie den Grund für die Sperrung aus',
      popupActionActive: 'Fahrzeug aufheben',
      popupActionDeactivate: 'Fahrzeug aussetzen',
    },
    activeStatusButton: {
      statusActive: 'Aktiv',
      statusDeactivate: 'Inaktiv',
    },
    formTabs: {
      informationTab: 'Information',
      notesTab: 'Hinweise',
      historyTab: 'Geschichte',
      reservationPreferencesTab: 'Reservierungspräferenzen',
    },
  },

  form: {
    header: {
      createVehicle: {
        title: 'Erstellen',
      },

      updateVehicle: {
        title: 'Aktualisieren',
      },
    },
    footer: {
      confirmButtonText: {
        create: 'Einreichen',
        update: 'Einreichen',
      },
    },
    information: {
      details: {
        header: 'Allgemeine Informationen',
        fields: {
          name: 'Name',
          site: 'Bereich',
          year: 'Jahr',
          location: 'Startort',
          make: 'Machen',
          model: 'Modell',
          color: 'Farbe',
          suppliers: 'Anbieter',
          code: 'Externe ID',
          vin: 'Fahrgestellnummer',
          productID: 'Produkt-ID',
          licensePlate: 'Kennzeichen',
          electric: 'Elektrisch',
          connectorType: 'Steckertyp',
          pricePerMinute: 'Kosten pro Minute',
        },
      },
      attributes: {
        header: 'Eigenschaften',
      },
      suppliers: {
        header: 'Anbieter',
        fields: {
          suppliers: 'Anbieter',
        },
      },
      mileageInspection: {
        header: 'Kilometerstand & Inspektion',
        fields: {
          mileage: 'Kilometerstand',
          mileageLastInspection: 'Kilometerstand bei der letzten Inspektion',
          lastInspectionDate: 'Datum der letzten Inspektion',
          nextInspectionDate: 'Nächster Inspektionstermin',
        },
      },
      capacity: {
        header: 'Kapazität',
        headerConfigurations: 'Kapazitätskonfigurationen',
        fields: {
          seats: 'Max. Sitzplätze',
          minSeats: 'Min. Sitzplätze',
          attribute: 'Attribut',
          count: 'Zählen',
        },
        btnAddConfig: {
          title: 'Konfiguration hinzufügen',
        },
      },
      deliveriesDetails: {
        header: 'Lieferdetails',
        fields: {
          maxWeight: 'Max. Gewicht',
          maxVolume: 'Maxi. Volumen',
        },
      },
      services: {
        header: 'Leistungen',
      },
      insurance: {
        header: 'Versicherung',
        fields: {
          typeOfInsurance1: 'Versicherungsart 1',
          typeOfInsurance1_start: 'Startdatum',
          typeOfInsurance1_end: 'Enddatum',
          typeOfInsurance2: 'Versicherungsart 2',
          typeOfInsurance2_start: 'Startdatum',
          typeOfInsurance2_end: 'Enddatum',
        },
      },
      dimensions: {
        header: 'Fahrzeugabmessungen',
      },
      getProductBtn: 'GETT-Produkt-IDs anzeigen',
      excludedProfiles: {
        header: 'Ausgeschlossene Profile',
        dualList: {
          profilesList: {
            header: 'Profilliste',
          },
          excludedList: {
            header: 'Ausgeschlossene Profile',
          },
        },
      },
    },
    valdations: {
      name: 'Name ist erforderlich',
      plateNumber: {
        matches: 'Die maximale Anzahl an Fahrgästen muss eine Zahl sein',
        required: 'Maximale Anzahl an Fahrgästen ist erforderlich',
      },
      service: 'Dienst mit ist erforderlich',
      pax: {
        matches: 'Personenzahl muss eine Zahl sein',
        required: 'Perosnenzahl ist erforderlich',
      },
      minSeats: {
        matches: 'Mindestanzahl an Sitzplätzen muss eine Zahl sein',
        required: 'Mindestanzahl an Sitzplätzen ist erforderlich',
      },
      model: 'Modell mit ist erforderlich',
      color: 'Farbe mit ist erforderlich',
      year: {
        matches: 'Das Jahr muss eine Zahl sein',
        required: 'Jahr ist erforderlich',
      },
      licenseExpDate: 'Lizenzablauf ist erforderlich',
    },
  },

  statuses: {
    online: 'Online',
    suspended: 'Gesperrt',
    onATrip: 'Auf einer Fahrt',
  },

  totalVehicles: 'Fahrzeuge insgesamt',
};

export default vehicles;
